export default {
  dns: { value: 'dns' },
  http: { value: 'http' },
  https: { value: 'https' },
  ssh: { value: 'ssh' },
  other: { value: 'other' },
  alert: { value: 'alert' },
};
